export interface IUserProfile {
  email: string;
  isLockedOut: boolean;
  isApproved: boolean;
  roles: Array<string>;
  firstName: string;
  lastName: string;
  userId: number;
  addressLine1: string;
  addressLine2: string;
  city: string;
  zipCode: string;
  state: string;
  range: number;
  latitude: number;
  longitude: number;
}

export class UserProfile implements IUserProfile {
  email: string;
  isLockedOut: boolean;
  isApproved: boolean;
  roles: Array<string>;
  firstName: string;
  lastName: string;
  userId: number;
  addressLine1: string;
  addressLine2: string;
  city: string;
  zipCode: string;
  state: string;
  range: number;
  latitude: number;
  longitude: number;
}
